import { MemorySliceStore } from "../../shared";

/** In-memory cache for persisted slice values (owned by {@link persistentSliceStore}). */
export const persistenceMemoryStore = new MemorySliceStore();
